import React from 'react'
import Header from '../Component/Header'
import { Link } from 'react-router-dom'
import Footer from'../Component/Footer' 
import { useEffect } from 'react'
const CbseResultAnalysis = () => {
    useEffect(() => {
        // Set the page title
        document.title = 'Cbse Result Analysis - Presentation Convent School Delhi';  
      }, []);
  return (
     <>
       <Header/>
        <div className="innerslide"> 
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>   Academic </li>
                <li>Cbse Result Analysis</li>
            </ul>
       </div>
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>Cbse Result Analysis</h1>
                    </div>
                </div>
                <div className="row">
                      <div className="col-lg-12">
                        <h5>Class XII</h5>
                      <div className="table-responsive maintable"> 
                      <table className="table">
                          <thead> 
                              <tr>
                                  <th>YEAR</th>
                                  <th>No of Students Appeared</th>
                                  <th>No of students passed</th>
                                  <th>Pass Percentage</th>
                                  <th>Highest score</th> 
                              </tr>
                          </thead>
                          <tbody>
                              <tr>
                                  <td>2024-25</td>
                                  <td>170</td>
                                  <td>170</td>
                                  <td>100%</td>
                                  <td>97.4%</td> 
                              </tr>
                              <tr>
                                  <td>2023-24</td>
                                  <td>181</td>
                                  <td>181</td>
                                  <td>100%</td>
                                  <td>97.20%</td> 
                              </tr>
                              <tr>
                                  <td>2022 - 23</td>
                                  <td>178</td>
                                  <td>177</td>
                                  <td>99.44%</td>
                                  <td>97.20%</td> 
                              </tr>
                          </tbody>
                      </table>
                      </div>
                      <h5>Class X</h5>
                      <div className="table-responsive maintable">
       
                      <table className="table">
                          <thead> 
                              <tr> 
                                  <th>YEAR</th>
                                  <th>No of Students Appeared</th>
                                  <th>No of students cleared</th>
                                  <th>Pass Percentage</th>
                                  <th>Highest score</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr> 
                                  <td>2024-25</td>
                                  <td>201</td>
                                  <td>201</td>
                                  <td>100%</td>
                                  <td>96.6%</td>
                              </tr>
                              <tr> 
                                  <td>2023-24</td>
                                  <td>188</td>
                                  <td>186</td>
                                  <td>98.94%</td>
                                  <td>97%</td>
                              </tr>
                              <tr>
                                  
                                  <td>2022-23</td>
                                  <td>212</td>
                                  <td>211</td>
                                  <td>99.53%</td>
                                  <td>97.20%</td>
                              </tr>
                          </tbody>
                      </table>
                      </div>
                      </div> 
                 </div>
            </div>  
        </div> 
       <Footer/>
     </>
  )
}

export default CbseResultAnalysis
